import React from 'react';
import links from '../../../../config/links';

import DescriptionStylable from '../../text/DescriptionStylable';
import ShareUrlPopUp from '../../InfoPopUps/ShareUrlPopUp';
import BackgroundImage from '../../BackgroundImage';
import CheckboxSA from '../../FormElementsStandalone/CheckboxSA';
import { ClubSubtypes } from '../../../utils/constants';
import withStatsig from '../../hocs/withStatsig';

import styles from '../dualMatch.scss';

class DualMatchHeaderDesktop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scoreTeam1: 0,
            scoreTeam2: 0,
            isWinnerTeam1: false,
            isWinnerTeam2: false,
            submitting: false,
        };
        this.handleScoreChange = this.handleScoreChange.bind(this);
        this.handleWinnerChange = this.handleWinnerChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { scoreTeam1, scoreTeam2, isWinnerTeam1, isWinnerTeam2 } = this.props;
        this.setState({
            scoreTeam1,
            scoreTeam2,
            isWinnerTeam1,
            isWinnerTeam2,
            submitting: false,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.scoreTeam1 !== this.state.scoreTeam1 || nextProps.scoreTeam2 !== this.state.scoreTeam2) {
            this.setState((prevState) => ({
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.scoreTeam1 !== prevState.scoreTeam1 ? { scoreTeam1: nextProps.scoreTeam1 } : {}),
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.scoreTeam2 !== prevState.scoreTeam2 ? { scoreTeam2: nextProps.scoreTeam2 } : {}),
            }));
        }

        if (nextProps.isWinnerTeam1 !== this.state.isWinnerTeam1 || nextProps.isWinnerTeam2 !== this.state.isWinnerTeam2) {
            this.setState((prevState) => ({
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.isWinnerTeam1 !== prevState.isWinnerTeam1 ? { isWinnerTeam1: nextProps.isWinnerTeam1 } : {}),
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.isWinnerTeam2 !== prevState.isWinnerTeam2 ? { isWinnerTeam2: nextProps.isWinnerTeam2 } : {}),
            }));
        }
    }

    handleScoreChange(score, team) {
        const newScore = score.slice(-2);
        this.setState({
            [team === 'team1' ? 'scoreTeam1' : 'scoreTeam2']: newScore,
        });
        this.props.handleScoreChange(newScore, this.props[team].clubId);
    }

    async handleWinnerChange(team) {
        const { isWinnerTeam1, isWinnerTeam2 } = this.state;
        const isWinner = team === 'team1' ? !isWinnerTeam1 : !isWinnerTeam2;

        this.setState({
            [team === 'team1' ? 'isWinnerTeam1' : 'isWinnerTeam2']: isWinner,
            [team === 'team1' ? 'isWinnerTeam2' : 'isWinnerTeam1']: false,
            submitting: true,
        });
        await this.props.handleWinnerChange(isWinner, this.props[team].clubId);
        this.setState({ submitting: false });
    }

    render() {
        const {
            isAdmin,
            isUserPowered,
            team1,
            team2,
            scoreTeam1,
            scoreTeam2,
            matchType,
            eventLocations,
            isTeamTennisMatch,
            displayMatchStatus,
            isCollegeDualMatch,
            checkGate,
            featureGates,
        } = this.props;

        const isRostersRolloutEnabled = checkGate(featureGates.ROSTERS_ROLLOUT);

        const showIsWinner = isAdmin;
        const getHeaderLabel = () => (isTeamTennisMatch ? 'Team Match' : 'Dual Match');

        return (
            <div>
                <div className={`${styles.headerTitle} mt16 mb8`}>
                    <div className={`${styles.description} text-highlight3 fs13`}>
                        {matchType || getHeaderLabel()}
                    </div>
                    <div className={styles.shareUrl}>
                        {
                            __CLIENT__ && !isCollegeDualMatch
                                ? (
                                    <ShareUrlPopUp
                                        title="Dual Match"
                                        data-testid="dual-match.header-new.share-popup"
                                    />
                                )
                                : null
                        }
                    </div>
                </div>
                <div className="d-flex flex-row align-items-stretch">
                    <div className="d-flex jce flex-1 mr32 mt24 mb24 position-relative">
                        <div className="d-flex flex-row align-items-center">
                            <div className="text-right mr32 ml-auto flex-1">
                                <h6
                                    className="title-uppercase clickable mb0"
                                    onClick={() => this.props.redirectTo(`/${isTeamTennisMatch ? 'clubs' : 'schools'}/${team1.clubId}`)}
                                >
                                    {team1.isCollege ? (team1.shortName || team1.displayName || team1.name) : (team1.displayName || team1.name)}
                                </h6>
                                {isRostersRolloutEnabled && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...(isUserPowered && team1.power6 ? [`${team1.power6.toFixed(2)} Power 6`] : []),
                                            ...(team1.location?.display ? [team1.location.display] : []),
                                        ]}
                                    />
                                )}
                                {!isRostersRolloutEnabled && (team1.clubSubTypeId === ClubSubtypes.MENS || team1.clubSubTypeId === ClubSubtypes.WOMENS) && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...(isUserPowered && team1.power6 ? [`${team1.power6.toFixed(2)} Power 6`] : []),
                                            ...(team1.location?.display ? [team1.location.display] : []),
                                        ]}
                                    />
                                )}
                                {!isRostersRolloutEnabled && (team1.clubSubTypeId === ClubSubtypes.COED) && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...((isUserPowered && team1.power6Men) ? [`${team1.power6Men.toFixed(2)} Power 6 Boys`] : []),
                                            ...((isUserPowered && team1.power6Women) ? [`${team1.power6Women.toFixed(2)} Power 6 Girls`] : []),
                                            ...(team1.location?.display ? [team1.location.display] : []),
                                        ]}
                                    />
                                )}

                                {isTeamTennisMatch && !isRostersRolloutEnabled && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...(team1.location?.display ? [team1.location.display] : []),
                                        ]}
                                    />
                                )}

                                {isAdmin && team1.rosterHasUnclaimedPlayers && (
                                    <div className="error-text">
                                        This team’s roster is incomplete, which might prevent you from entering every match result. The coach must add their missing players and complete their roster using this <a href={links.hsRosterArticle} rel="noopener noreferrer" target="_blank">support guide</a>.
                                    </div>
                                )}
                            </div>
                            <div>
                                <BackgroundImage
                                    baseUrl={'/v1/club/'}
                                    defaultImage={'/img/utr-ball--teal.svg'}
                                    images={team1.clubProfileImages}
                                    imageType={'profile'}
                                    parentStylesClass={'team-logo'}
                                />
                                {showIsWinner && (
                                    <div className="fs13 mt8 text-right">
                                        Is Winner
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="match-status">
                        {!isAdmin && displayMatchStatus && (
                            <div className="flex-1 d-flex flex-row align-items-center justify-content-center">
                                <div className={`team-score-value ${scoreTeam1 > scoreTeam2 ? 'text-dark' : ''}`}>
                                    {scoreTeam1}
                                </div>
                                <span className={`winner-arrow ml8 ${(scoreTeam1 > scoreTeam2) ? 'text-dark visible' : 'invisible'}`}>{'\u25C0'}</span>
                                <div className="text-center ml32 mr32">
                                    FINAL
                                </div>
                                <span className={`winner-arrow mr8 ${(scoreTeam2 > scoreTeam1) ? 'text-dark visible' : 'invisible'}`}>{'\u25B6'}</span>
                                <div className={`team-score-value ${scoreTeam2 > scoreTeam1 ? 'text-dark' : ''}`}>
                                    {scoreTeam2}
                                </div>
                            </div>
                        )}
                        {isAdmin && (
                            <div className="flex-1 d-flex flex-row align-items-center justify-content-center">
                                <div className={`team-score-input`}>
                                    <input
                                        type="number"
                                        placeholder="0"
                                        min={0}
                                        max={99}
                                        className="form-control dashed"
                                        value={this.state.scoreTeam1 || 0}
                                        onChange={(e) => this.handleScoreChange(e.target.value, 'team1')}
                                    />
                                    {showIsWinner && (
                                        <div className="text-center mt32">
                                            <CheckboxSA
                                                checked={this.state.isWinnerTeam1 || false}
                                                onChange={() => this.handleWinnerChange('team1')}
                                                disabled={this.state.submitting}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="text-center ml32 mr32">
                                    VS
                                </div>
                                <div className={`team-score-input`}>
                                    <input
                                        type="number"
                                        placeholder="0"
                                        min={0}
                                        max={99}
                                        className="form-control dashed"
                                        value={this.state.scoreTeam2 || 0}
                                        onChange={(e) => this.handleScoreChange(e.target.value, 'team2')}
                                    />
                                    {showIsWinner && (
                                        <div className="text-center mt32">
                                            <CheckboxSA
                                                checked={this.state.isWinnerTeam2 || false}
                                                onChange={() => this.handleWinnerChange('team2')}
                                                disabled={this.state.submitting}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="d-flex flex-1 ml32 mt24 mb24 position-relative">
                        <div className="d-flex flex-row align-items-center">
                            <div>
                                <BackgroundImage
                                    baseUrl={'/v1/club/'}
                                    defaultImage={'/img/utr-ball--teal.svg'}
                                    images={team2.clubProfileImages}
                                    imageType={'profile'}
                                    parentStylesClass={'team-logo'}
                                />
                                {showIsWinner && (
                                    <div className="fs13 mt8 text-left">
                                        Is Winner
                                    </div>
                                )}
                            </div>
                            <div className="text-left ml32 mr-auto flex-1">
                                <h6
                                    className="title-uppercase clickable mb0"
                                    onClick={() => this.props.redirectTo(`/${isTeamTennisMatch ? 'clubs' : 'schools'}/${team2.clubId}`)}
                                >
                                    {team2.isCollege ? (team2.shortName || team2.displayName || team2.name) : (team2.displayName || team2.name)}
                                </h6>
                                {isRostersRolloutEnabled && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...(isUserPowered && team2.power6 ? [`${team2.power6.toFixed(2)} Power 6`] : []),
                                            ...(team2.location?.display ? [team2.location.display] : []),
                                        ]}
                                    />
                                )}
                                {!isRostersRolloutEnabled && (team2.clubSubTypeId === ClubSubtypes.MENS || team2.clubSubTypeId === ClubSubtypes.WOMENS) && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...(isUserPowered && team2.power6 ? [`${team2.power6.toFixed(2)} Power 6`] : []),
                                            ...(team2.location?.display ? [team2.location.display] : []),
                                        ]}
                                    />
                                )}
                                {!isRostersRolloutEnabled && (team2.clubSubTypeId === ClubSubtypes.COED) && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...((isUserPowered && team2.power6Men) ? [`${team2.power6Men.toFixed(2)} Power 6 Boys`] : []),
                                            ...((isUserPowered && team2.power6Women) ? [`${team2.power6Women.toFixed(2)} Power 6 Girls`] : []),
                                            ...(team2.location?.display ? [team2.location.display] : []),
                                        ]}
                                    />
                                )}

                                {isTeamTennisMatch && !isRostersRolloutEnabled && (
                                    <DescriptionStylable
                                        className={`fs14`}
                                        desc={[
                                            ...(team2.location?.display ? [team2.location.display] : []),
                                        ]}
                                    />
                                )}
                                {isAdmin && team2.rosterHasUnclaimedPlayers && (
                                    <div className="error-text">
                                        This team’s roster is incomplete, which might prevent you from entering every match result. The coach must add their missing players and complete their roster using this <a href={links.hsRosterArticle} rel="noopener noreferrer" target="_blank">support guide</a>.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-row align-items-center mt8">
                    <div className="mr-auto ml-auto text-small show-ellipsis">
                        <DescriptionStylable desc={[eventLocations[0]?.locationDisplay || '']} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withStatsig(DualMatchHeaderDesktop);
